import { useAppDispatch, useAppSelector } from 'hooks';
import { FC } from 'react';
import { selectEstimateAutoFilledData, selectEstimateNotes, updateEstimateNotes } from '../../estimatesSlice';
import { CustomTextArea } from 'components';
import AutoFilledIndicator from 'components/auto-filled-indicator/AutoFilledIndicator';
import { VoidFn } from 'types/baseTypes';
import { notesMaxCount } from 'containers/settings/constants';

interface EstimateNotesSectionProps {
  className?: string;
  handleOnFocus: VoidFn;
}

const EstimateNotesSection: FC<EstimateNotesSectionProps> = ({ className, handleOnFocus }) => {
  const selectedEstimateNotes = useAppSelector(selectEstimateNotes);
  const autoFilledData = useAppSelector(selectEstimateAutoFilledData);
  const dispatch = useAppDispatch();

  const isNotesAutoFilled =
    Boolean(autoFilledData?.note?.trim()) &&
    (autoFilledData?.note?.trim() ?? '') === (selectedEstimateNotes?.trim() ?? '');

  const handleNoteChange = (value: string) => {
    dispatch(updateEstimateNotes(value));
  };

  return (
    <div className={className}>
      <div className="mb-2 flex items-center text-17px font-semibold text-heading">
        Notes
        <AutoFilledIndicator isAutoFilled={isNotesAutoFilled} />
      </div>
      <div className="mb-4">
        <CustomTextArea
          resizeTextArea={true}
          id="create-estimate-notes"
          maxLength={notesMaxCount}
          name="notes"
          placeholder="Enter notes here"
          value={selectedEstimateNotes ?? ''}
          onChange={handleNoteChange}
          className="py-[15px] text-[17px] font-normal leading-5
            text-heading outline-none placeholder:text-[17px]"
          onFocus={handleOnFocus}
          showRemainingChar={true}
        />
      </div>
    </div>
  );
};

export default EstimateNotesSection;
